import axiosInstance from "../../../utils/axios";
import {
  createCompany,
  findExistingCompany,
  setCompanyFirstContact,
  updateCompany,
} from "../../bitrix/company";
import {
  createContact,
  findExistingContact,
  setContactFirstContact,
  updateContact,
} from "../../bitrix/contact";
import { createDeal, setDealProducts } from "../../bitrix/deal";
import { dbCompanyToBitrixMapper } from "../mappers/companyMapper";
import { dbContactToBitrixMapper } from "../mappers/contactMapper";
import {
  proposedDealMapper,
  proposedDealProductMapper,
} from "../mappers/dealMapper";
import { ProposedOrder } from "../types/order";

export const createOrder = async (order: ProposedOrder): Promise<string> => {
  let bitrixCompanyId = order.company?.ID;
  let bitrixContactId = order.contact.ID;

  if (!bitrixCompanyId && order.company) {
    const fields = dbCompanyToBitrixMapper(
      order.company,
      order.accountId,
      order.accountName
    );
    // Si la empresa ya existe en Bitrix se reutiliza en vez de duplicarla, y se le
    // completan los campos de Parnerus. La migracion dejo pares duplicados y la app
    // los seguia generando.
    const existente = await findExistingCompany(order.company.TITLE, order.accountId);
    if (existente) {
      bitrixCompanyId = existente;
      await updateCompany({ ID: existente, ...fields }).catch((error) =>
        console.error("No se pudieron actualizar los campos de la empresa existente", error)
      );
    } else {
      bitrixCompanyId = await createCompany(fields);
    }
    if (order.mediadorId) {
      // Igual que en contactos: si falla, la orden sigue.
      await setCompanyFirstContact(bitrixCompanyId, order.mediadorId).catch(
        (error) => console.error("No se pudo asignar el First Contact de la empresa", error)
      );
    }
    axiosInstance.post("/api/company/update-bitrix-id", {
      companyId: order.company.companyId,
      bitrixId: bitrixCompanyId,
    });
  }

  if (!bitrixContactId) {
    const fields = dbContactToBitrixMapper(
      order.contact,
      order.accountId,
      order.accountName
    );
    const existente = await findExistingContact(
      order.contact.EMAIL,
      order.contact.PHONE,
      order.accountId
    );
    if (existente) {
      bitrixContactId = existente;
      await updateContact({ ID: existente, ...fields, COMPANY_ID: bitrixCompanyId }).catch((error) =>
        console.error("No se pudieron actualizar los campos del contacto existente", error)
      );
    } else {
      bitrixContactId = await createContact(fields, bitrixCompanyId);
    }
    if (order.mediadorId) {
      // Si esto falla la orden tiene que seguir: el contacto ya esta creado y el
      // First Contact es un dato secundario.
      await setContactFirstContact(bitrixContactId, order.mediadorId).catch(
        (error) => console.error("No se pudo asignar el First Contact", error)
      );
    }
    axiosInstance.post("/api/contact/update-bitrix-id", {
      contactId: order.contact.contactId,
      bitrixId: bitrixContactId,
    });
  }

  const dealId = await createDeal(
    proposedDealMapper(bitrixContactId, bitrixCompanyId),
    order.files,
    order.accountId,
    order.mediadorId,
    order.invoiceId
  );

  // Put current Bitrix product pricing
  const updatedProducts = order.products.map((product) => ({
    ...product,
    price: order.productsList.find((p) => p.ID === product.id)
      ? Number(order.productsList.find((p) => p.ID === product.id)?.PRICE)
      : 0,
    total: order.productsList.find((p) => p.ID === product.id)
      ? Number(order.productsList.find((p) => p.ID === product.id)?.PRICE) *
        product.quantity
      : 0,
  }));

  await setDealProducts(dealId, updatedProducts.map(proposedDealProductMapper));

  return dealId;
};
